import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import PlanImage from '@/pages/PlanImage'
import ProjectList from '@/pages/ProjectList'
import ProjectAggregation from '@/pages/ProjectAggregation'
// import ProductionImage from '@/pages/ProductionImage'
import DeliveredImage from '@/pages/DeliveredImage'
import DeliveredImageSp from '@/pages/DeliveredImageSp'
import DeliveredImageLoginSp from '@/pages/DeliveredImageLoginSp'
import OrderList from '@/pages/OrderList'
import DeliveryEvaluation from '@/pages/DeliveryEvaluation'
import OrderDetail from '@/pages/OrderDetail'
import NotFound from '@/pages/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      // 企画画像登録
      path: '/plan_image/:itemCode',
      name: 'PlanImage',
      component: PlanImage
    },
    {
      // 案件一覧
      path: '/project_list',
      name: 'ProjectList',
      component: ProjectList
    },
    // {
    //   // 施工画像登録
    //   path: '/production_image',
    //   name: 'ProductionImage',
    //   component: ProductionImage
    // },
    {
      // 納品画像登録
      path: '/delivered_image/:projectNumber',
      name: 'DeliveredImage',
      component: DeliveredImage
    },
    {
      // データ集計
      path: '/aggregate_projects',
      name: 'ProjectAggregation',
      component: ProjectAggregation
    },
    {
      path: '/delivered_image_sp/:projectNumber',
      name: 'DeliveredImageSp',
      component: DeliveredImageSp
    },
    {
      path: '/delivered_image_login_sp',
      name: 'DeliveredImageLoginSp',
      component: DeliveredImageLoginSp
    },
    {
      path: '/order_list',
      name: 'OrderList',
      component: OrderList
    },
    {
      path: '/delivery_evaluation',
      name: 'DeliveryEvaluation',
      component: DeliveryEvaluation
    },
    {
      path: '/order_detail/:orderNo',
      name: 'OrderDetail',
      component: OrderDetail
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})

router.afterEach((to, from) => {
  document.title = (process.env.APP_ENV !== 'production') ? '【テスト環境】LINKs(制作担当)' : 'LINKs(制作担当)'
})

router.beforeEach((to, from, next) => {
  if (from.path.indexOf('delivery_evaluation') === -1 && to.path.indexOf('delivery_evaluation') === -1) {
    next()
  } else {
    let userid = to.query.userId
    if ('userId' in to.query) {
      delete to.query['userId']
      to.meta['userId'] = userid
      next({
        path: to.path,
        query: to.query,
        meta: { userId: userid }
      })
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js